import { makeStyles } from '@material-ui/core';
import { createStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette, MIDDLE_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    accordionRoot: {
      background: 'transparent',
      boxShadow: 'none',
      margin: 0,
      marginBottom: 18,
      '&:before': {
        display: 'none',
      },
      '&$accordionExpanded': {
        marginTop: 0,
        marginBottom: 0,
        '&:last-child': {
          marginBottom: MIDDLE_MARGIN,
        },
      },
    },
    accordionExpanded: {},
    accordionSummary: {
      fontSize: 18,
      fontWeight: 'bold',
      color: colorsPalette.white,
      borderBottom: `2px solid ${colorsPalette.violetAnalyticsCard}`,
      padding: '10px 0',
      margin: 0,
      minHeight: 46,
    },
    accordionSummaryExpanded: {
      color: colorsPalette.white,
      margin: '0 !important',
      minHeight: 'unset !important',
    },
    accordionSummaryContent: {
      margin: 0,
      display: 'flex',
      alignItems: 'center',
    },
    accordionDetails: {
      padding: 0,
      paddingTop: 18,
    },
    accordionIconBlock: {
      marginRight: 13,
      marginLeft: 5,
      width: 14,
      height: 14,
      position: 'relative',
      '&::before': {
        display: 'block',
        content: '""',
        width: 14,
        height: 2,
        background: theme.palette.primary.light,
        marginTop: 6,
      },
      '&::after': {
        display: 'block',
        content: '""',
        width: 14,
        height: 2,
        background: theme.palette.primary.light,
        marginTop: -2,
        transform: 'rotate(-90deg)',
        transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      },
      '&.active::after': {
        transform: 'rotate(0deg)',
      },
    },
  }),
);

export default useStyles;
